module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ การกำหนดรูปแบบการวาง และ ตำแหน่งของ Element ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Border\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      }
    }
  }, [_vm._v("\n            Box Size   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-box-position"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Box Position\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Position")]), _vm._v(" "), _c('li', [_vm._v("• Left")]), _vm._v(" "), _c('li', [_vm._v("• Right")]), _vm._v(" "), _c('li', [_vm._v("• Top")]), _vm._v(" "), _c('li', [_vm._v("• Bottom")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pst-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("position")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_l-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("left")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_r-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("right")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_t-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("top")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("bottom")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_l-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_r-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_t-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bt-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("50pct")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pst-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("stt")]), _vm._v(" สำหรับ \"static\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rlt")]), _vm._v(" สำหรับ \"relative\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("asl")]), _vm._v(" สำหรับ \"absolute\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("f")]), _vm._v(" สำหรับ \"fixed\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Position")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Position -->\n<!-- Left -->\n<div class=\"_pst-rlt _l-1px\"></div>\n<div class=\"_pst-rlt _l-2px\"></div>\n<div class=\"_pst-rlt _l-4px\"></div>\n<div class=\"_pst-rlt _l-8px\"></div>\n<div class=\"_pst-rlt _l-16px\"></div>\n<div class=\"_pst-rlt _l-32px\"></div>\n<div class=\"_pst-rlt _l-64px\"></div>\n\n<!-- Right -->\n<div class=\"_pst-rlt _r-1px\"></div>\n<div class=\"_pst-rlt _r-2px\"></div>\n<div class=\"_pst-rlt _r-4px\"></div>\n<div class=\"_pst-rlt _r-8px\"></div>\n<div class=\"_pst-rlt _r-16px\"></div>\n<div class=\"_pst-rlt _r-32px\"></div>\n<div class=\"_pst-rlt _r-64px\"></div>\n\n<!-- Top -->\n<div class=\"_pst-rlt _t-1px\"></div>\n<div class=\"_pst-rlt _t-2px\"></div>\n<div class=\"_pst-rlt _t-4px\"></div>\n<div class=\"_pst-rlt _t-8px\"></div>\n<div class=\"_pst-rlt _t-16px\"></div>\n\n<!-- Bottom -->\n<div class=\"_pst-rlt _bt-1px\"></div>\n<div class=\"_pst-rlt _bt-2px\"></div>\n<div class=\"_pst-rlt _bt-4px\"></div>\n<div class=\"_pst-rlt _bt-8px\"></div>\n<div class=\"_pst-rlt _bt-16px\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-1px"
  }, [_c('small', [_vm._v("._l-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-2px"
  }, [_c('small', [_vm._v("._l-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-4px"
  }, [_c('small', [_vm._v("._l-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-8px"
  }, [_c('small', [_vm._v("._l-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-16px"
  }, [_c('small', [_vm._v("._l-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-32px"
  }, [_c('small', [_vm._v("._l-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-64px"
  }, [_c('small', [_vm._v("._l-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-1px"
  }, [_c('small', [_vm._v("._r-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-2px"
  }, [_c('small', [_vm._v("._r-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-4px"
  }, [_c('small', [_vm._v("._r-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-8px"
  }, [_c('small', [_vm._v("._r-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-16px"
  }, [_c('small', [_vm._v("._r-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-32px"
  }, [_c('small', [_vm._v("._r-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-64px"
  }, [_c('small', [_vm._v("._r-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-1px"
  }, [_c('small', [_vm._v("._t-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-2px"
  }, [_c('small', [_vm._v("._t-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-4px"
  }, [_c('small', [_vm._v("._t-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-8px"
  }, [_c('small', [_vm._v("._t-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-16px"
  }, [_c('small', [_vm._v("._t-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-1px"
  }, [_c('small', [_vm._v("._bt-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-2px"
  }, [_c('small', [_vm._v("._bt-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-4px"
  }, [_c('small', [_vm._v("._bt-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-8px"
  }, [_c('small', [_vm._v("._bt-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-16px"
  }, [_c('small', [_vm._v("._bt-16px")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7c91baa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicBoxPosition.vue
// module id = 143
// module chunks = 0